import {
  ADD_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  EXCHANGE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  EDIT_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  DELETE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST,
  SKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST
} from './constants';

export const addItemToShipment = (
  clubMemberShipmentId,
  item,
  successFunction,
  errorFunction
) => ({
  type: ADD_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  clubMemberShipmentId,
  item,
  successFunction,
  errorFunction
});

export const exchangeItemOnShipment = (
  clubMemberShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
) => ({
  type: EXCHANGE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  clubMemberShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
});

export const editItemOnShipment = (
  clubMemberShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
) => ({
  type: EDIT_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  clubMemberShipmentId,
  productVariantId,
  item,
  successFunction,
  errorFunction
});

export const removeItemFromShipment = (
  clubMemberShipmentId,
  productVariantId,
  successFunction,
  errorFunction
) => ({
  type: DELETE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  clubMemberShipmentId,
  productVariantId,
  successFunction,
  errorFunction
});

export const shipShipmentNow = (clubMemberShipmentId, successFunction) => ({
  type: PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST,
  clubMemberShipmentId,
  successFunction
});

export const skipShipment = (clubMemberShipmentId, successFunction) => ({
  type: SKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  clubMemberShipmentId,
  successFunction
});

export const unskipShipment = (clubMemberShipmentId, successFunction) => ({
  type: UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  clubMemberShipmentId,
  successFunction
});
